'use client'

import { useState, useEffect } from 'react'

import { HomeBackground } from './home-background'

/**
 * Client island owning the deferred WebGL mount decision. Keeping this isolated
 * lets the homepage (`page.tsx`) stay a Server Component so only the canvas gate
 * and the sections that need interactivity ship as client bundles.
 */
export function HomeCanvasGate() {
  const [mountCanvas, setMountCanvas] = useState(false)

  useEffect(() => {
    const skipCanvas =
      window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
      window.matchMedia('(max-width: 768px)').matches
    if (skipCanvas) {
      return
    }

    const mount = () => setMountCanvas(true)
    if ('requestIdleCallback' in window) {
      const id = requestIdleCallback(mount, { timeout: 3000 })
      return () => cancelIdleCallback(id)
    }
    const t = setTimeout(mount, 200)
    return () => clearTimeout(t)
  }, [])

  return <HomeBackground mountCanvas={mountCanvas} />
}
